import { Pressable } from "react-native";
import { Caption, Text } from "react-native-paper";

import type { IconType } from "../../icon";
import { useAppTheme } from "../../useAppTheme";
import AudioPlayerContainer from "../AudioPlayerContainer";
import Box from "../Box";
import Button from "../Button";

export const PassageStem = ({
	parentStem,
	parentAudio,
	toggleShowReadMore,
	parentTitle,
	handleTracking,
	readMoreCta,
	stiumulusIcon,
	caption,
}: {
	parentStem?: string;
	toggleShowReadMore?: () => void;
	parentAudio?: string;
	parentTitle?: string;
	readMoreCta: string;
	stiumulusIcon: IconType;
	caption: string;
	handleTracking?: (uri: string, type: "ended" | "started" | "paused") => void;
}) => {
	const theme = useAppTheme();

	return (
		<Box
			backgroundColor={theme.colors.surface}
			borderTopWidth={1}
			borderTopColor={theme.colors.surfaceVariant}
			borderBottomWidth={1}
			borderBottomColor={theme.colors.surfaceVariant}
			gap={16}
			paddingHorizontal={16}
			paddingVertical={16}
		>
			{parentAudio && (
				<AudioPlayerContainer
					uri={parentAudio}
					handleTracking={handleTracking}
				/>
			)}
			{parentStem || parentTitle ? (
				<Pressable onPress={toggleShowReadMore}>
					<Box
						flexDirection="row"
						justifyContent="space-between"
						alignItems="center"
						gap={8}
					>
						<Box flex={1}>
							<Text variant="titleMedium" numberOfLines={1}>
								{parentTitle}
							</Text>
							<Caption>{caption}</Caption>
						</Box>
						<Button
							icon={stiumulusIcon}
							mode="outlined"
							onPress={toggleShowReadMore}
							style={{
								borderColor: theme.colors.primary,
							}}
						>
							{readMoreCta}
						</Button>
					</Box>
				</Pressable>
			) : null}
		</Box>
	);
};
